import React from "react";
import styled from "@emotion/styled";
import { Checkbox } from "../Checkbox/Checkbox";

const MultiSelect = ({ options, cols, testId, onChange }: MultiSelectProps) => {
  const handleChange = (id: string, newValue: boolean) => {
    const updatedList = options.map((option) => {
      if (id === option.id) {
        option.checked = newValue;
      }
      return option;
    });

    onChange(updatedList);
  };

  return (
    <Container cols={cols} data-testid={testId}>
      {options.map(({ id, checked, text }) => (
        <Checkbox
          key={id}
          type="checkbox"
          name={id}
          checked={checked}
          onChange={() => handleChange(id, !checked)}
          label={text}
        />
      ))}
    </Container>
  );
};

type Option = {
  id: string;
  checked: boolean;
  text: string;
};

type MultiSelectProps = {
  options: Option[];
  testId: string;
  cols?: number;
  onChange: (updatedValues: Option[]) => void;
};

const Container = styled.div<{ cols?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols ?? 1}, 1fr);
  gap: 16px;
`;

export type { MultiSelectProps };
export { MultiSelect };
